// extracted by mini-css-extract-plugin
export default {"courseAttendedContainer":"UtapCourseAttendedCheckBox_courseAttendedContainer__97tWh","error":"UtapCourseAttendedCheckBox_error__Op+wG"};